export default __webpack_public_path__ + "static/media/flag_uk.4e740676.webp";